const DEFAULT_ROOT_MARGIN = '200px';

export const useLazyVisible = (
  target: Ref<HTMLElement | null>,
  rootMargin: string = DEFAULT_ROOT_MARGIN,
) => {
  const isVisible: Ref<boolean> = ref(false);
  let observer: IntersectionObserver | null = null;

  const disconnect = (): void => {
    observer?.disconnect();
    observer = null;
  };

  const observe = (element: HTMLElement): void => {
    disconnect();
    observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        isVisible.value = true;
        disconnect();
      },
      { rootMargin },
    );
    observer.observe(element);
  };

  onMounted(() => {
    if (!('IntersectionObserver' in window)) {
      isVisible.value = true;
      return;
    }

    const stopWatch = watch(
      target,
      (element) => {
        if (element) observe(element);
        else disconnect();
      },
      { immediate: true, flush: 'post' },
    );

    watch(isVisible, (value) => {
      if (!value) return;
      disconnect();
      stopWatch();
    });
  });

  onBeforeUnmount(disconnect);

  return { isVisible };
};

export default useLazyVisible;
